const React = require('react')
const { component } = require('../odo/odojs')
const inject = require('injectinto')
const ql = require('../odo/odoql').use('store')
const route = require('odo-route')
const markdown = require('../shared/markdown')
const normalpage = require('./normalpage')
const Input = require('../shared/input')

route('/contact', p => {
  return { page: 'contact' }
})

inject.bind(
  'page:contact',
  component({
    query: params => ({
      content: ql.store(['contact'], 'content')
    }),
    render: (state, params, hub) => {
      document.title = 'Asset Altitude'
      const changes = params.changes ?? {}
      const valid = params.valid ?? {}

      const rem = f => e => {
        e.preventDefault()
        hub.emit('update', {
          valid: { ...valid, [f]: [null, ''].includes(e.target.value) ? 'invalid' : 'valid' },
          changes: { ...changes, [f]: e.target.value }
        })
      }

      const send = e => {
        e.preventDefault()
        if (params.waiting) return
        const v = Object.values(valid)
        const c = Object.values(changes)
        if (v.includes('invalid')) return
        if (c.length < 1 || c.some(val => [null, ''].includes(val))) return
        if (!params.waiting) hub.emit('update', { waiting: true }, hub.emit('fire all cannons', { ...changes }))
      }

      return normalpage(
        <>
          {markdown(state.content.contact)}
          <Input label='NAME' onChange={rem('name')} valid={valid.name} />
          <br />
          <Input label='EMAIL' onChange={rem('email')} valid={valid.email} />
          <br />
          <Input label='MESSAGE' type='plaintext' onChange={rem('message')} valid={valid.message} />
          <p>
            {!params.waiting ? (
              <button className='button primary' onClick={send}>
                Send message
              </button>
            ) : (
              <span>Sending&hellip;</span>
            )}
          </p>
        </>
      )
    }
  })
)

route('/contact/thankyou', p => {
  return { page: 'contact:thankyou' }
})

inject.bind(
  'page:contact:thankyou',
  component({
    query: params => ({
      content: ql.store(['contact_thankyou'], 'content')
    }),
    render: (state, params, hub) => {
      document.title = 'Asset Altitude'
      return normalpage(markdown(state.content.contact_thankyou))
    }
  })
)
